export const data = [
  {
    name: "React",
    value: 80,
  },
  {
    name: "Node.js",
    value: 65,
  },
  {
    name: "Javascript",
    value: 90,
  },
  {
    name: "HTML",
    value: 90,
  },
  {
    name: "CSS",
    value: 90,
  },
  {
    name: "Bootstrap",
    value: 90,
  },
  {
    name: "Laravel",
    value: 50,
  },
  {
    name: "ReactNative",
    value: 70,
  },
  {
    name: "Flutter",
    value: 40,
  },
];
